module.exports = __webpack_public_path__ + "static/media/light@2x.5f4ece65.png";